define("shared/components/shared/social/basic-display-deprecation/modal", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div {{did-insert this.checkInstagramPersonalAccounts}}>
    {{#if this.showBasicDisplayDeprecationModal}}
      <Shared::Modal @close={{this.closeModal}} as |modal|>
        <modal.card class="tOB--image__deprecationIG">
          <modal.card-body>
            <div class="u--row u--row--noCollapse">
              <div class="u--col__7 u--col__push--5">
                <modal.card-header class="u--p__b__0">
                  <h1 class="o--modalHeader__title u--text--lg u--p__b__sm">
                    {{t "basic-display-deprecation.modal.title"}}
                  </h1>
                  <p class="u--text--md"> {{t "basic-display-deprecation.modal.subtitle"}}</p>
                </modal.card-header>
  
                <modal.card-body>
                  <p class="u--text--bold u--text--md">
                    {{t
                      "basic-display-deprecation.modal.affected_profiles"
                      socialProfileCount=this.instagramProfiles.length
                    }}
                  </p>
                  <ul class="tBD--list">
                    {{#each this.instagramProfiles as |instagramProfile|}}
                      <li class="tBD--list__socialProfile">
                        <Shared::ProfileAvatar
                          @showDetails={{t "basic-display-deprecation.modal.instagram_personal"}}
                          @showPlatform={{true}}
                          @socialProfile={{instagramProfile}}
                        />
                      </li>
                    {{/each}}
                  </ul>
  
                  <div class="u--relative">
                    <p>{{html-safe (t "basic-display-deprecation.modal.tip")}}</p>
                    <Shared::Ui::Button
                      @additional="block"
                      @onClick={{this.openInstagram}}
                      @size="large"
                      @variant="primary"
                    >
                      {{t "basic-display-deprecation.modal.swtich_profiles"}}
                      {{svg-jar "external" class="o--icon u--m__l__xs"}}
                    </Shared::Ui::Button>
  
                    <Shared::Ui::Button
                      @additional="block"
                      @onClick={{this.showWizard}}
                      @size="large"
                      @variant="none"
                      class="u--text--hl"
                    >
                      {{t "basic-display-deprecation.modal.switch"}}
                    </Shared::Ui::Button>
                  </div>
                </modal.card-body>
              </div>
            </div>
          </modal.card-body>
        </modal.card>
      </Shared::Modal>
    {{/if}}
  </div>
  
  {{#if this.showBasicDisplayDeprecationWizard}}
    <Shared::Social::BasicDisplayDeprecation::Wizard
      @closeWizard={{this.closeModal}}
      @returnToModal={{this.returnToModal}}
    />
  {{/if}}
  */
  {
    "id": "DW/ZPxbg",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"checkInstagramPersonalAccounts\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showBasicDisplayDeprecationModal\"]],[[[1,\"    \"],[8,[39,2],null,[[\"@close\"],[[30,0,[\"closeModal\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card\"]],[[24,0,\"tOB--image__deprecationIG\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--col__7 u--col__push--5\"],[12],[1,\"\\n              \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b__0\"]],null,[[\"default\"],[[[[1,\"\\n                \"],[10,\"h1\"],[14,0,\"o--modalHeader__title u--text--lg u--p__b__sm\"],[12],[1,\"\\n                  \"],[1,[28,[35,3],[\"basic-display-deprecation.modal.title\"],null]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,2],[14,0,\"u--text--md\"],[12],[1,\" \"],[1,[28,[35,3],[\"basic-display-deprecation.modal.subtitle\"],null]],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n\\n              \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n                \"],[10,2],[14,0,\"u--text--bold u--text--md\"],[12],[1,\"\\n                  \"],[1,[28,[35,3],[\"basic-display-deprecation.modal.affected_profiles\"],[[\"socialProfileCount\"],[[30,0,[\"instagramProfiles\",\"length\"]]]]]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,\"ul\"],[14,0,\"tBD--list\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"instagramProfiles\"]]],null]],null],null,[[[1,\"                    \"],[10,\"li\"],[14,0,\"tBD--list__socialProfile\"],[12],[1,\"\\n                      \"],[8,[39,6],null,[[\"@showDetails\",\"@showPlatform\",\"@socialProfile\"],[[28,[37,3],[\"basic-display-deprecation.modal.instagram_personal\"],null],true,[30,2]]],null],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[2]],null],[1,\"                \"],[13],[1,\"\\n\\n                \"],[10,0],[14,0,\"u--relative\"],[12],[1,\"\\n                  \"],[10,2],[12],[1,[28,[35,7],[[28,[37,3],[\"basic-display-deprecation.modal.tip\"],null]],null]],[13],[1,\"\\n                  \"],[8,[39,8],null,[[\"@additional\",\"@onClick\",\"@size\",\"@variant\"],[\"block\",[30,0,[\"openInstagram\"]],\"large\",\"primary\"]],[[\"default\"],[[[[1,\"\\n                    \"],[1,[28,[35,3],[\"basic-display-deprecation.modal.swtich_profiles\"],null]],[1,\"\\n                    \"],[1,[28,[35,9],[\"external\"],[[\"class\"],[\"o--icon u--m__l__xs\"]]]],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\\n                  \"],[8,[39,8],[[24,0,\"u--text--hl\"]],[[\"@additional\",\"@onClick\",\"@size\",\"@variant\"],[\"block\",[30,0,[\"showWizard\"]],\"large\",\"none\"]],[[\"default\"],[[[[1,\"\\n                    \"],[1,[28,[35,3],[\"basic-display-deprecation.modal.switch\"],null]],[1,\"\\n                  \"]],[]]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[1]]]]],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showBasicDisplayDeprecationWizard\"]],[[[1,\"  \"],[8,[39,10],null,[[\"@closeWizard\",\"@returnToModal\"],[[30,0,[\"closeModal\"]],[30,0,[\"returnToModal\"]]]],null],[1,\"\\n\"]],[]],null]],[\"modal\",\"instagramProfile\"],false,[\"did-insert\",\"if\",\"shared/modal\",\"t\",\"each\",\"-track-array\",\"shared/profile-avatar\",\"html-safe\",\"shared/ui/button\",\"svg-jar\",\"shared/social/basic-display-deprecation/wizard\"]]",
    "moduleName": "shared/components/shared/social/basic-display-deprecation/modal.hbs",
    "isStrictMode": false
  });
  const BASIC_DISPLAY_DEPRECATION_MODAL_CACHE_KEY = 'basic_display_deprecation_modal';
  let BasicDisplayDeprecationModalComponent = _exports.default = (_class = class BasicDisplayDeprecationModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _initializerDefineProperty(this, "showBasicDisplayDeprecationModal", _descriptor3, this);
      _initializerDefineProperty(this, "showBasicDisplayDeprecationWizard", _descriptor4, this);
    }
    get instagramProfiles() {
      return this.auth.currentGroup.instagramProfiles.filter(socialProfile => !socialProfile.isProfessional);
    }
    get groupHasInstagramPersonalAccounts() {
      return Boolean(this.instagramProfiles?.length);
    }
    get cacheKey() {
      return `${BASIC_DISPLAY_DEPRECATION_MODAL_CACHE_KEY}_${this.auth.currentGroup.id}`;
    }
    get hasSeenModalToday() {
      return Boolean(this.cache.retrieve(this.cacheKey));
    }
    checkInstagramPersonalAccounts() {
      if (this.groupHasInstagramPersonalAccounts && !this.hasSeenModalToday) {
        this.showBasicDisplayDeprecationModal = true;
        this.cache.add(this.cacheKey, true, {
          expiry: this.cache.expiry(1, 'day'),
          persist: true
        });
      }
    }
    openInstagram() {
      window.open('https://www.instagram.com/accounts/convert_to_professional_account/', '_blank', 'noopener');
    }
    showWizard() {
      this.showBasicDisplayDeprecationModal = false;
      this.showBasicDisplayDeprecationWizard = true;
    }
    closeModal() {
      this.showBasicDisplayDeprecationModal = false;
      this.showBasicDisplayDeprecationWizard = false;
    }
    returnToModal() {
      this.showBasicDisplayDeprecationModal = true;
      this.showBasicDisplayDeprecationWizard = false;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showBasicDisplayDeprecationModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showBasicDisplayDeprecationWizard", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "checkInstagramPersonalAccounts", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "checkInstagramPersonalAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openInstagram", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openInstagram"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showWizard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showWizard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "returnToModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "returnToModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BasicDisplayDeprecationModalComponent);
});